import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["descricao", "submit", "form"]

  connect() {
    // When Turbo renders a stream that replaces the form,
    // focus the last input automatically.
    this.focusLastInput()
  }

  loadDescricao(event) {
    const modeloId = event.target.value
    this.submitTarget.disabled = true

    if (!modeloId) {
      this.descricaoTarget.innerHTML = ""
      return
    }

    // Loading message
    this.descricaoTarget.innerHTML = `
      <div class="d-flex align-items-center">
        <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
        <span>Carregando descrição...</span>
      </div>
    `

    fetch(`/fluxos/${modeloId}/descricao`, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then(response => {
        if (!response.ok) throw new Error("Erro ao carregar")
        return response.text()
      })
      .then(html => {
        Turbo.renderStreamMessage(html)
        this.submitTarget.disabled = false
      })
      .catch(() => {
        this.descricaoTarget.innerHTML = `
          <span class="text-danger">Erro ao carregar descrição.</span>
        `
      })
  }

  submitStep(event) {
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  // 🔥 Automatically focus the last input whenever Turbo replaces the form
  focusLastInput() {
    const container = document.querySelector("#fluxo_form")
    if (!container) return

    let lastInput

    // Find the FIRST focusable input INSIDE the replaced DOM
    const inputs = container.querySelectorAll(
      "input:not([type=hidden]):not([type=submit]):not([disabled]), textarea:not([disabled]), select:not([disabled])"
    )

    // 1. Procura um campo CEP dentro do container
    const cepInput = container.querySelector("[data-cep-endereco-target='cep']");

    // 2. Caso exista, esse vira o seu lastInput
    if (cepInput) {
      lastInput = cepInput;
    } else {
      // Fallback normal
      const inputs = container.querySelectorAll(
        "input:not([type=hidden]):not([disabled]):not([type=submit]):not([type=button]), textarea:not([disabled]), select:not([disabled])"
      );
      lastInput = inputs[inputs.length - 1];
    }

    
    console.log(lastInput)
    if (lastInput)  {
      setTimeout(() => {
        lastInput.focus()
        const len = lastInput.value.length
        lastInput.setSelectionRange(len, len) // joga o cursor pro fim
      }, 30)
    }
  }
}
